import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ExpenseItem } from './expense-item.model';
import * as ExpenseItemActions from './expense-item.actions';

export const expenseItemsFeatureKey = 'expenseItems';

export interface State extends EntityState<ExpenseItem> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ExpenseItem> = createEntityAdapter<ExpenseItem>({selectId: (model: ExpenseItem) => model.EIListID});

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});


export const expenseItemReducer = createReducer(
  initialState,
  on(ExpenseItemActions.addExpenseItem,
    (state, action) => adapter.addOne(action.expenseItem, state)
  ),
  on(ExpenseItemActions.upsertExpenseItem,
    (state, action) => adapter.upsertOne(action.expenseItem, state)
  ),
  on(ExpenseItemActions.addExpenseItems,
    (state, action) => adapter.addMany(action.expenseItems, state)
  ),
  on(ExpenseItemActions.upsertExpenseItems,
    (state, action) => adapter.upsertMany(action.expenseItems, state)
  ),
  on(ExpenseItemActions.updateExpenseItem,
    (state, action) => adapter.updateOne(action.expenseItem, state)
  ),
  on(ExpenseItemActions.updateExpenseItems,
    (state, action) => adapter.updateMany(action.expenseItems, state)
  ),
  on(ExpenseItemActions.deleteExpenseItem,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ExpenseItemActions.deleteExpenseItems,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ExpenseItemActions.loadExpenseItems,
    (state, action) => adapter.setAll(action.expenseItems, state)
  ),
  on(ExpenseItemActions.clearExpenseItems,
    state => adapter.removeAll(state)
  ),
);

export function reducer(state: State | undefined, action: Action) {
  return expenseItemReducer(state, action);
}

export const selectExpenseItemState = createFeatureSelector<State>(
  expenseItemsFeatureKey
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors(selectExpenseItemState);
